import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import useAuth from "./useAuth";
import { poolData, ensureProjectEnvReady } from "./UserPool";

function RequireAuth ({ children }) {
  const { accessToken, authed, refreshToken} = useAuth();
  const location = useLocation();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    poolData.refreshToken = refreshToken; 
    poolData.accessToken = accessToken;
  }, [accessToken, refreshToken]);

  useEffect(() => {
    let cancelled = false;

    async function prepare() {
      if (!authed) {
        setReady(false);
        return;
      }
      try {
        // Ensure we have a token
        try { refreshToken && refreshToken(); } catch (_) { /* */ }
        const ok = await ensureProjectEnvReady(poolData.accessToken || accessToken);
        if (!cancelled) setReady(!!ok);
      } catch (_) {
        if (!cancelled) setReady(true); // fail-open to avoid blocking UI
      }
    }

    prepare();
    return () => { cancelled = true; };
  }, [authed, accessToken, refreshToken]);

  if (authed !== true) {
    return <Navigate to="/checkLogin" replace state={{ path: location.pathname }} />;
  }

  // Block children until project/env are ready
  if (!ready) {
    return null; // lightweight gate; Suspense/loader handled at route level
  }

  return children;
}

RequireAuth.propTypes = {
  children: PropTypes.any,
  clientAssessment: PropTypes.any
};

export default RequireAuth;
